import { BlogCategoryArticlesWrapper } from './BlogCategoryArticlesWrapper';
import { BlogMenu } from './BlogMenu/BlogMenu';
import Heading from 'components/Basic/Heading/Heading';
import Webline from 'components/Layout/Webline/Webline';
import React, { useRef } from 'react';
import { BlogCategoryDetailType } from 'types/blogCategory';

type BlogCategoryProps = {
    blogCategory: BlogCategoryDetailType;
};

const BlogCategory: FC<BlogCategoryProps> = ({ blogCategory }) => {
    const paginationScrollTargetRef = useRef<null | HTMLDivElement>(null);

    return (
        <Webline>
            <div ref={paginationScrollTargetRef}>
                <div className="mb-16 flex flex-col vl:flex-row">
                    <div className="order-2 flex w-full flex-col vl:flex-1">
                        <div>
                            <Heading
                                className="my-0 -mx-5 py-4 px-5 text-h6 font-medium leading-6 notVl:border-t-2 notVl:border-solid notVl:border-gray"
                                type="h1"
                            >
                                {blogCategory.name}
                            </Heading>
                        </div>

                        <BlogCategoryArticlesWrapper uuid={blogCategory.uuid} />
                    </div>

                    <div className="order-1 flex w-full flex-col pr-8 vl:w-[300px]">
                        <BlogMenu items={blogCategory.blogCategoriesTree} activeItemUuid={blogCategory.uuid} />
                    </div>
                </div>
            </div>
        </Webline>
    );
};

export default BlogCategory;
